<template>
    <div>
        <vs-row>
            <vs-col vs-w="12">
                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Destinataires(s)</p></vs-divider>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Service(s) :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <span v-for="(service, j) in resource.services" :key="j">
                                {{ service.title }}
                        </span>
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Périmètre valideur</p></vs-divider>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Service du contributeur :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <span v-for="(service, j) in resource.contribution_services" :key="j">
                                {{ service.title }}
                        </span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Service du valideur :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <span v-for="(service, j) in resource.validation_services" :key="j">
                                {{ service.title }}
                        </span>
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Contenu</p></vs-divider>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Grille :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <span v-for="(grid, j) in resource.grids" :key="j">
                            <vs-chip
                                color="primary"
                            >
                                {{ grid.title }}
                            </vs-chip>
                        </span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Questionnaire(s) :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-chip color="primary">
                            {{resource.rating_questionnaire.name}}
                        </vs-chip>
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Analyse</p></vs-divider>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Question(s) d'analyse :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-chip color="primary">
                            {{resource.campaign_questionnaire.name}}
                        </vs-chip>
                    </div>
                </div>

                <vs-divider position="left" class="mt-20 font-bold"><p class="bold">Séquence</p></vs-divider>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date 1er envoi :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.sent_date_1"
                            type="date"
                            name="addCampaignFirstDate"
                            class="w-full"
                            :disabled="true"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date 2eme envoi :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.sent_date_2"
                            type="date"
                            name="addCampaignSecondDate"
                            class="w-full"
                            :disabled="true"
                        />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date 3eme envoi :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.sent_date_3"
                            type="date"
                            name="addCampaignThirdDate"
                            class="w-full"
                            :disabled="true"
                        />
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>

import Multiselect from "vue-multiselect"

export default {
    components: {Multiselect},
    props: {
        value: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            log: console.log,
            resource: {},
        };
    },
    created() {
        this.initResource();
    },
    computed: {},
    watch: {},
    methods: {
        initResource() {
            this.resource = {
                type: this.value.type,
                title: this.value.title,
                rating_questionnaire: this.value.rating_questionnaire,
                campaign_questionnaire: this.value.campaign_questionnaire,
                services: this.value.services,
                users: this.value.users,
                start_date : this.value.start_date,
                end_date : this.value.end_date,
                sent_date_1 : this.$moment(this.value.sent_date_1).format("YYYY-MM-DD"),
                sent_date_2 : this.$moment(this.value.sent_date_2).format("YYYY-MM-DD"),
                sent_date_3 : this.$moment(this.value.sent_date_3).format("YYYY-MM-DD"),
                contribution_services: this.value.contribution_services,
                validation_services: this.value.validation_services,
                grids: this.value.grids,
            }
            console.log('this.resource',this.resource)
        },
       
    }
};
</script>
<style scoped></style>
